export const MAX_FAVORITES = 5;
export const MAX_RECENTLY_SEARCHED = 5;

// The ammount of time to wait after the user has stopped typing input the
// input box before triggering a search request.
export const SEARCHING_DELAY = 400;

